<script lang="ts">
	import Button, { Label, Icon } from '@smui/button/styled';

	export let margin = false;
	export let variant = 'text';
	export let inline = true;
	export let icon = '';
	export let fullWidth = false;
</script>

<div class:inline class:margin class:fullWidth>
	<Button {variant} on:click>
		<Label>
			{#if icon}
				<Icon class="material-icons">{icon}</Icon>
			{/if}
		</Label>
		<slot />
	</Button>
</div>

<style>
	.inline {
		display: inline-block;
	}

	div.margin {
		margin: 4px 10px 4px 0;
	}

	div.margin:last-child {
		margin-right: 0;
	}
	div.fullWidth {
		min-width: 100%;
	}

	div.fullWidth :global(.mdc-button) {
		min-width: 100%;
	}
</style>
